import * as React from 'react';
import { ProfileProvider } from '@app/Contexts/ProfileProvider';
import { Outlet } from 'react-router-dom';

export const DefaultLayout = () => (
  <main className="px-3 py-4">
    <Outlet />
  </main>
);
